import { CommonModule, DatePipe } from '@angular/common';
import { NavbarService } from './services/shared/navbar.service';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER, Injectable, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { AppRoutingModule } from '@app/app-routing.module';

// import { AngularFontAwesomeModule } from 'angular-font-awesome';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpInterceptor } from '@angular/common/http';
import { HttpConfigInterceptor } from '@app/interceptor/httpconfiginterceptor';
import { AutocompleteComponent } from '@app/autocomplete/autocomplete.component';
import { MedlemreportComponent } from '@app/reports/medlemreport/medlemreport.component';
import { InstitutionreportComponent } from '@app/reports/institutionreport/institutionreport.component';
import { MeetingreportComponent } from '@app/reports/meetingreport/meetingreport.component';
import { MemberformComponent } from '@app/components/members/memberform/memberform.component';
import { NewmemberComponent } from '@app/components/members/newmember/newmember.component';
import { InstitutionsComponent } from '@app/components/institutions/institutions.component';
import { AddInstitutionComponent } from '@app/components/institutions/add-institution.component';
import { SearchinstitutionsComponent } from '@app/components/institutions/searchinstitutions/searchinstitutions.component';
import { NarvarohanteringComponent } from '@app/components/institutions/narvarohantering/narvarohantering.component';
import { NavbarComponent } from '@app/components/shared/nav/navbar/navbar.component';
import { FooterComponent } from '@app/components/shared/footer/footer.component';
import { NotFoundComponent } from '@app/components/shared/notfound/notfound.component';
import { LoginComponent } from '@app/components/shared/login/login/login.component';
import { StartComponent } from '@app/components/shared/start/start.component';
import { AuthService } from '@app/services/auth/auth.service';
import { AuthGuardService } from '@app/services/authentication/auth-guard.service';
import { RoleguardService } from '@app/services/authentication/roleguard.service';
import { CapitalizePipe } from '@app/pipes/capitalize.pipe';
import { UserfilterPipe } from '@app/pipes/userfilter.pipe';
import { UnauthorizedComponent } from '@app/services/authentication/unauthorized/unauthorized.component';
// import { SignincallbackComponent } from '@app/services/authentication/signincallback/signincallback.component';
import { ErrormessageComponent } from '@app/components/shared/error/errormessage/errormessage.component';
import { ErrorService } from '@app/services/error.service';
import { KontoinformationComponent } from '@app/components/members/kontoinformation/kontoinformation.component';
import { NymedlemLagerComponent } from '@app/components/members/lager/nymedlem/nymedlem.component';
import { UppdragComponent } from '@app/components/members/loger/uppdrag/uppdrag.component';
import { LoaderInterceptorService } from '@app/interceptor/loaderinterceptor.service';
import { LoaderComponent } from '@app/components/shared/loader/loader.component';
//import { UserManager } from 'oidc-client';
import { MeetingsComponent } from '@app/components/members/memberform/meetings/meetings/meetings.component';
import { SignsComponent } from '@app/components/members/memberform/signs/signs/signs.component';
import { PasswordValidatorDirective } from '@app/components/shared/validators/password-validator.directive';
import { MeetingdetailsComponent } from '@app/components/members/memberform/meetings/meetingdetails/meetingdetails.component';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatSortModule} from '@angular/material/sort';
import { MemberformService } from '@app/services/states/memberform/memberform.service';

import { CreateMemberCanDeactivateGuardService } from '@app/routeguard/create-member-can-deactivate-guard.service';
import { SearchmemberComponent } from '@app/components/members/searchmember/searchmember.component';
import { MemberofficesComponent } from '@app/components/members/memberform/memberoffices/memberoffices/memberoffices.component';
import { DisableControlDirective } from '@app/directives/DisableControlDirective.directive';
import { MembershipComponent } from '@app/components/members/memberform/membership/membership.component';
import { RegistermeetingComponent } from '@app/components/institutions/registermeeting/registermeeting.component';
import {MatSelectModule} from '@angular/material/select';
import { GraderComponent } from '@app/components/members/loger/grader/grader.component';
import {MatCheckboxModule} from '@angular/material/checkbox';
// import { SignsUpdateComponent } from '@app/components/members/loger/signs-update/signs-update.component';
import { AddofficeComponent } from '@app/components/members/memberform/addoffice/addoffice.component';
import {MatDatepickerModule} from '@angular/material/datepicker';
import { MatNativeDateModule, MAT_DATE_LOCALE } from '@angular/material/core';
import {MatSidenavModule} from '@angular/material/sidenav';
import { MatDialogModule } from '@angular/material/dialog';
// import { MatMomentDateModule, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { MemberService } from '@app/services/member.service';


import { ConfirmdialogComponent } from '@app/components/shared/dialog/confirmdialog/confirmdialog.component';
import { InstitutionfilterPipe } from '@app/pipes/institution.pipe';
import { AutoComponent } from '@app/components/members/autocompletetest/auto/auto.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { ChangepasswordComponent } from '@app/components/members/changepassword/changepassword.component';
import { HandlememberfeesComponent } from '@app/components/institutions/memberfees/handlememberfees/handlememberfees.component';
import { HandlefeesComponent } from '@app/components/institutions/memberfees/handlefees/handlefees.component';
import { RegisterpaymentsComponent } from '@app/components/institutions/memberfees/registerpayments/registerpayments.component';
// tslint:disable-next-line:max-line-length
import { RegisterpaymentsmultiComponent } from '@app/components/institutions/memberfees/registerpaymentsmulti/registerpaymentsmulti.component';
import { NedsattningComponent } from '@app/components/institutions/memberfees/nedsattning/nedsattning/nedsattning.component';
import { SearchmeetingComponent } from '@app/components/institutions/narvarohantering/searchmeeting/searchmeeting.component';
import { AddmeetingComponent } from '@app/components/institutions/narvarohantering/addmeeting/addmeeting.component';
import {MatCardModule} from '@angular/material/card';
import { AttendantsFilterPipe } from '@app/pipes/attendants.pipe';
import { ResetpasswordComponent } from '@app/components/shared/resetpassword/resetpassword.component';
import { Resetpassword2Component } from '@app/components/shared/resetpassword2/resetpassword2.component';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import { LillamatrikelnComponent } from '@app/reports/lillamatrikeln/lillamatrikeln.component';
import { SoftsubscribersComponent } from '@app/reports/softsubscribers/softsubscribers.component';
import { BirthdaylistComponent } from '@app/reports/birthdaylist/birthdaylist.component';
import { MembershipeditComponent } from '@app/components/members/memberform/membership/membershipedit/membershipedit.component';
import { AddmembershipComponent } from '@app/components/members/memberform/membership/addmembership/addmembership.component';
// tslint:disable-next-line:max-line-length
import { ChangeprimaryinstitutionComponent } from '@app/components/members/memberform/membership/changeprimaryinstitution/changeprimaryinstitution.component';
// tslint:disable-next-line:max-line-length
import { TerminatemembershipComponent } from '@app/components/members/memberform/membership/terminatemembership/terminatemembership.component';
// tslint:disable-next-line:max-line-length
import { TerminatemembershipcampComponent } from '@app/components/members/memberform/membership/terminatemembershipcamp/terminatemembershipcamp.component';
import { TerminatemembershipstorlogeComponent } from '@app/components/members/memberform/membership/terminatemembershipstorloge/terminatemembershipstorloge.component';

import { GetinstitutionsperdistrictComponent } from '@app/reports/getinstitutionsperdistrict/getinstitutionsperdistrict.component';
import { MatrixComponent } from '@app/reports/matrix/matrix.component';
// tslint:disable-next-line:max-line-length
import { NarvaroregistreringComponent } from '@app/components/institutions/narvarohantering/narvaroregistrering/narvaroregistrering.component';
import { AgedistributionComponent } from '@app/reports/agedistribution/agedistribution.component';
import { DebiteringslistaComponent } from '@app/reports/debiteringslista/debiteringslista.component';
import { MailComponent } from '@app/components/shared/mail/mail.component';
import { EditorComponent } from '@app/components/shared/editor/editor/editor.component';
import { NewinstitutionsperyearComponent } from '@app/reports/newinstitutionsperyear/newinstitutionsperyear.component';
import { FileuploadComponent } from '@app/components/shared/fileupload/fileupload.component';
import { QuillModule } from 'ngx-quill';
import { AddsignComponent } from '@app/components/members/memberform/addsign/addsign.component';
import { PaidfeesComponent } from '@app/components/members/memberform/paidfees/paidfees.component';
import { MemberdetailsComponent } from '@app/components/members/newmember/memberdetails/memberdetails.component';
import { SignreportComponent } from '@app/reports/signreport/signreport.component';
import { OfficereportComponent } from '@app/reports/officereport/officereport.component';
import { AdminComponent } from '@app/components/members/admin/admin.component';
import { NewInstitutionsPerYearComponent } from './reports/statistik/new-institutions-per-year/new-institutions-per-year.component';
import {DropdownModule} from 'primeng/dropdown';
import { MembershipFlowComponent } from './reports/statistik/membership-flow/membership-flow.component';
import {FieldsetModule} from 'primeng/fieldset';
import { InstitutionChooserComponent } from './components/shared/institution-chooser/institution-chooser.component';
import { CalendarComponent } from './components/shared/calendar/calendar.component';
import { CommonSearchViewComponent } from './reports/statistik/shared/common-search-view/common-search-view.component';
import { CausesComponent } from './reports/statistik/causes/causes.component';
import { PresencePerMeetingComponent } from './reports/statistik/presence-per-meeting/presence-per-meeting.component';
import { PresenceInstitutionlevelComponent } from './reports/statistik/presence-institutionlevel/presence-institutionlevel.component';
import {InputSwitchModule} from 'primeng/inputswitch';
import { ListboxModule } from 'primeng/listbox';
import { AccordionModule } from 'primeng/accordion';
import { CheckboxModule } from 'primeng/checkbox';
import { MenubarModule } from 'primeng/menubar';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { SliderModule } from 'primeng/slider';
import { InputTextModule } from 'primeng/inputtext';
import { CalendarModule } from 'primeng/calendar';
import { SelectButtonModule } from 'primeng/selectbutton';
import { ContentComponent } from './components/shared/help/content/content.component';
import { CalendarnotrequiredComponent } from './components/shared/calendarnotrequired/calendarnotrequired.component';
import { TreeTableModule } from 'primeng/treetable';
import {ToastModule} from 'primeng/toast';
import { ImageCropperModule } from 'ngx-image-cropper';
import { LoadPhotoComponent } from './components/shared/load-photo/load-photo.component';
import { AttendancePerInstitutionPerMonthComponent } from './reports/statistik/attendance-per-institution-per-month/attendance-per-institution-per-month.component';
import { AttendanceMemberLevelComponent } from './reports/statistik/attendance-member-level/attendance-member-level.component';
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import { AttendancePerInstitutionWithinInstitutionDistrictComponent } from './reports/statistik/attendance-per-institution-within-institution-district/attendance-per-institution-within-institution-district.component';
import { AdminOfficesComponent } from './components/admin/admin-offices/admin-offices.component';
import {ToggleButtonModule} from 'primeng/togglebutton';
import { AdminOfficesEditComponent } from './components/admin/admin-offices-edit/admin-offices-edit.component';

import { AdminCommitteesComponent } from './components/admin/admin-committees/admin-committees.component';
import { AdminCommitteesEditComponent } from './components/admin/admin-committees-edit/admin-committees-edit.component';
import { AdminOfficeCommitteesComponent } from './components/admin/admin-office-committees/admin-office-committees.component';
import { AdminOfficeCommitteesAddComponent } from './components/admin/admin-office-committees-add/admin-office-committees-add.component';
import { AdminElectableCommitteesComponent } from './components/admin/admin-electable-committees/admin-electable-committees.component';
import { AdminElectableCommitteesAddComponent } from './components/admin/admin-electable-committees-add/admin-electable-committees-add.component';
import { PaymentEditComponent } from './components/institutions/memberfees/registerpayments/payment-edit/payment-edit.component';
import { EditNedsattningComponent } from './components/institutions/memberfees/nedsattning/edit-nedsattning/edit-nedsattning.component';
import { GottstaendeEttReportComponent } from './reports/gottstaende-ett-report/gottstaende-ett-report.component';
import { AdminSignsComponent } from './components/admin/admin-signs/admin-signs.component';
import { AdminSignsEditComponent } from './components/admin/admin-signs-edit/admin-signs-edit.component';
import { AdminOfficesAddComponent } from './components/admin/admin-offices-add/admin-offices-add.component';
import { AdminSignsAddComponent } from './components/admin/admin-signs-add/admin-signs-add.component';
import { AdminElectableSignsComponent } from './components/admin/admin-electable-signs/admin-electable-signs.component';
import { AdminElectableSignsAddComponent } from './components/admin/admin-electable-signs-add/admin-electable-signs-add.component';
import { AdminSystemAccessComponent } from './components/admin/admin-system-access/admin-system-access.component';
import { ResetPasswordDialogComponent } from './components/shared/reset-password-dialog/reset-password-dialog.component';
import { GottstaendeTvaReportComponent } from './reports/gottstaende-tva-report/gottstaende-tva-report.component';
import { VideoComponent } from './components/shared/video/video.component';
import {SplitButtonModule} from 'primeng/splitbutton';
import { AdminCommitteesAddComponent } from './components/admin/admin-committees-add/admin-committees-add.component';
import { FeetestComponent } from './components/test/feetest/feetest.component';
import { AdminInstitutionTypeComponent } from './components/admin/admin-institution-type/admin-institution-type.component';
import { AdminInstitutionTypeAddComponent } from './components/admin/admin-institution-type-add/admin-institution-type-add.component';
import { AdminInstitutionTypeEditComponent } from './components/admin/admin-institution-type-edit/admin-institution-type-edit.component';
import { AdminInstitutionGroupComponent } from './components/admin/admin-institution-group/admin-institution-group.component';
import { AdminInstitutionGroupAddComponent } from './components/admin/admin-institution-group-add/admin-institution-group-add.component';
import { AdminInstitutionGroupEditComponent } from './components/admin/admin-institution-group-edit/admin-institution-group-edit.component';
import { AdminOfficeTypeComponent } from './components/admin/admin-office-type/admin-office-type.component';
import { AdminOfficeTypeAddComponent } from './components/admin/admin-office-type-add/admin-office-type-add.component';
import { AdminOfficeTypeEditComponent } from './components/admin/admin-office-type-edit/admin-office-type-edit.component';
import { AdminSignTypeComponent } from './components/admin/admin-sign-type/admin-sign-type.component';
import { AdminSignTypeAddComponent } from './components/admin/admin-sign-type-add/admin-sign-type-add.component';
import { AdminSignTypeEditComponent } from './components/admin/admin-sign-type-edit/admin-sign-type-edit.component';
import { AdminCausesComponent } from './components/admin/admin-causes/admin-causes.component';
import { AdminCausesAddComponent } from './components/admin/admin-causes-add/admin-causes-add.component';
import { AdminCausesEditComponent } from './components/admin/admin-causes-edit/admin-causes-edit.component';
import { AdminCountryEditComponent } from './components/admin/admin-country-edit/admin-country-edit.component';
import { AdminCountryComponent } from './components/admin/admin-country/admin-country.component';
import { AdminCountryAddComponent } from './components/admin/admin-country-add/admin-country-add.component';
import { PanelMenuModule } from 'primeng/panelmenu';
import { AdminSystemPermissionsComponent } from './components/admin/admin-system-permissions/admin-system-permissions.component';
import { AdminSystemPermissionsAddComponent } from './components/admin/admin-system-permissions-add/admin-system-permissions-add.component';
import { AdminSystemPermissionsEditComponent } from './components/admin/admin-system-permissions-edit/admin-system-permissions-edit.component';
import { AdminOfficesListComponent } from './components/admin/admin-offices-list/admin-offices-list.component';
import { AdminConnectAccessesAndRolesComponent } from './components/admin/admin-connect-accesses-and-roles/admin-connect-accesses-and-roles.component';
import { AdminConnectAccessesAndRolesEditComponent } from './components/admin/admin-connect-accesses-and-roles-edit/admin-connect-accesses-and-roles-edit.component';
import { AddMemberComponent } from './components/members/add-member/add-member.component';
import { AdminLockUnlockSystemComponent } from './components/admin/admin-lock-unlock-system/admin-lock-unlock-system.component';
import { AdminGdprComponent } from './components/admin/admin-gdpr/admin-gdpr.component';
import { CalendarTimestampComponent } from './components/shared/calendar-timestamp/calendar-timestamp.component';
import { MemberMatrixComponent } from './components/institutions/member-matrix/member-matrix.component';
import {EditorModule} from 'primeng/editor';
import { WelcomeInfoComponent } from './components/shared/welcome-info/welcome-info.component';
import { VideoService } from './services/video.service';
import { AdminCreateAccountComponent } from './components/admin/admin-create-account/admin-create-account.component';
import { AdminRemoveMemberComponent } from './components/admin/admin-remove-member/admin-remove-member.component';
import { AdminRecalculateFeesMemberComponent } from './components/admin/admin-recalculate-fees-member/admin-recalculate-fees-member.component';
import { AuthModule, LogLevel } from 'angular-auth-oidc-client';
import { AppComponent } from './app.component';
import { ActivatedRouteSnapshot, DetachedRouteHandle, RouteReuseStrategy } from '@angular/router';


import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { SelectModule } from 'primeng/select';
import { DatePickerModule } from 'primeng/datepicker';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { MessageService, ConfirmationService } from 'primeng/api';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DrawerModule } from 'primeng/drawer';
import { InfoComponent } from './components/shared/info/info.component';
import { MultiSelectModule } from 'primeng/multiselect';
import { environment } from "environments/environment";
import { PopoverModule } from 'primeng/popover';
import { FeeHelpComponent } from './components/admin/fee-help/fee-help.component';
import { ImpersonateComponent } from './components/shared/nav/impersonate/impersonate.component';

import { SentMailsComponent } from './components/members/memberform/sent-mails/sent-mails.component';
import { FailedMailsComponent } from './components/members/memberform/failed-mails/failed-mails.component';
import { SlFilesComponent } from './components/institutions/sl-files/sl-files.component';
import { AllfailedmailsComponent } from './components/members/allfailedmails/allfailedmails.component';

// This impl. bases upon one that can be found in the router's test cases.
@Injectable()
export class CustomReuseStrategy implements RouteReuseStrategy {

  handlers: {[key: string]: DetachedRouteHandle} = {};

  shouldDetach(route: ActivatedRouteSnapshot): boolean {

      return true;
  }

  store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle): void {

      this.handlers[route.routeConfig.path] = handle;
  }

  shouldAttach(route: ActivatedRouteSnapshot): boolean {

      return !!route.routeConfig && !!this.handlers[route.routeConfig.path];
  }

  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle {

      if (!route.routeConfig) {return null; }
      return this.handlers[route.routeConfig.path];
  }

  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {

      return future.routeConfig === curr.routeConfig;
  }

}
@NgModule({
  declarations: [
    ResetpasswordComponent,
    Resetpassword2Component,
    AppComponent,
    NavbarComponent,
    StartComponent,
    LoginComponent,
    InstitutionsComponent,
    AddInstitutionComponent,

    NotFoundComponent,
    NewmemberComponent,
    AutocompleteComponent,
    MemberformComponent,
    FooterComponent,
    SearchinstitutionsComponent,
    MedlemreportComponent,
    InstitutionreportComponent,
    MeetingreportComponent,
    NarvarohanteringComponent,
    UnauthorizedComponent,
    ErrormessageComponent,
    KontoinformationComponent,
    NymedlemLagerComponent,
    UppdragComponent,
    GraderComponent,
    MeetingsComponent,
    SignsComponent,
    MeetingdetailsComponent,
    SearchmemberComponent,
    MemberofficesComponent,
    DisableControlDirective,
    MembershipComponent,
    RegistermeetingComponent,
    MemberdetailsComponent,
    AddofficeComponent,
    ConfirmdialogComponent,
    AutoComponent,
    ChangepasswordComponent,
    HandlememberfeesComponent,
    HandlefeesComponent,
    RegisterpaymentsComponent,
    RegisterpaymentsmultiComponent,
    NedsattningComponent,
    SearchmeetingComponent,
    AddmeetingComponent,
    LillamatrikelnComponent,
    SoftsubscribersComponent,
    BirthdaylistComponent,
    MembershipeditComponent,
    AddmembershipComponent,
    ChangeprimaryinstitutionComponent,
    TerminatemembershipComponent,
    TerminatemembershipcampComponent,
    TerminatemembershipstorlogeComponent,
    GetinstitutionsperdistrictComponent,
    MatrixComponent,
    NarvaroregistreringComponent,
    AgedistributionComponent,
    DebiteringslistaComponent,
    MailComponent,
    EditorComponent,
    NewinstitutionsperyearComponent,
    FileuploadComponent,
    AddsignComponent,
    PaidfeesComponent,
    SignreportComponent,
    OfficereportComponent,
    NewInstitutionsPerYearComponent,
    MembershipFlowComponent,
    InstitutionChooserComponent,
    CalendarComponent,
    CalendarnotrequiredComponent,
    CommonSearchViewComponent,
    CausesComponent,
    PresencePerMeetingComponent,
    PresenceInstitutionlevelComponent,
    AdminComponent,
    ContentComponent,
    LoadPhotoComponent,
    AttendancePerInstitutionPerMonthComponent,
    AttendanceMemberLevelComponent,
    AttendancePerInstitutionWithinInstitutionDistrictComponent,
    AdminOfficesComponent,
    AdminOfficesEditComponent,
    AdminCommitteesComponent,
    AdminCommitteesEditComponent,
    AdminOfficeCommitteesComponent,
    AdminOfficeCommitteesAddComponent,
    AdminElectableCommitteesComponent,
    AdminElectableCommitteesAddComponent,
    PaymentEditComponent,
    EditNedsattningComponent,
    GottstaendeEttReportComponent,
    AdminSignsComponent,
    AdminSignsEditComponent,
    AdminOfficesAddComponent,
    AdminSignsAddComponent,
    AdminElectableSignsComponent,
    AdminElectableSignsAddComponent,
    AdminSystemAccessComponent,
    ResetPasswordDialogComponent,
    GottstaendeTvaReportComponent,
    VideoComponent,
    AdminCommitteesAddComponent,
    FeetestComponent,
    AdminInstitutionTypeComponent,
    AdminInstitutionTypeAddComponent,
    AdminInstitutionTypeEditComponent,
    AdminInstitutionGroupComponent,
    AdminInstitutionGroupAddComponent,
    AdminInstitutionGroupEditComponent,
    AdminOfficeTypeComponent,
    AdminOfficeTypeAddComponent,
    AdminOfficeTypeEditComponent,
    AdminSignTypeComponent,
    AdminSignTypeAddComponent,
    AdminSignTypeEditComponent,
    AdminCausesComponent,
    AdminCausesAddComponent,
    AdminCausesEditComponent,
    AdminCountryComponent,
    AdminCountryAddComponent,
    AdminCountryEditComponent,
    AdminSystemPermissionsComponent,
    AdminSystemPermissionsAddComponent,
    AdminSystemPermissionsEditComponent,
    AdminOfficesListComponent,
    AdminConnectAccessesAndRolesComponent,
    AdminConnectAccessesAndRolesEditComponent,
    AddMemberComponent,
    AdminLockUnlockSystemComponent,
    AdminGdprComponent,
    AdminCreateAccountComponent,
    CalendarTimestampComponent,
    MemberMatrixComponent,
    WelcomeInfoComponent,
    AdminRemoveMemberComponent,
    AdminRecalculateFeesMemberComponent,
    CapitalizePipe,
    UserfilterPipe,
    InstitutionfilterPipe,
    PasswordValidatorDirective,
    AttendantsFilterPipe,
    LoaderComponent,
    InfoComponent,
    FeeHelpComponent,
    ImpersonateComponent,
    SentMailsComponent,
    FailedMailsComponent,
    SlFilesComponent,
    AllfailedmailsComponent
  ],
  imports: [
    AuthModule.forRoot({
        config: {
            authority: environment.openIdConnectSettings.authority,
            redirectUrl: environment.openIdConnectSettings.redirect_uri,
            postLogoutRedirectUri: environment.openIdConnectSettings.post_logout_redirect_uri,
            clientId: environment.openIdConnectSettings.client_id,
            scope: 'openid profile email roles offline_access ofmembersapi',
            responseType: 'code',
            silentRenew: true,
            renewTimeBeforeTokenExpiresInSeconds: 10,
            useRefreshToken: true,
            logLevel: LogLevel.Error,
           /* authority: 'https://localhost:44395',
            redirectUrl: window.location.origin,
            postLogoutRedirectUri: window.location.origin,
            clientId: 'angularclient',
            scope: 'openid profile email dataEventRecords roles offline_access',
            responseType: 'code',
            silentRenew: true,
            renewTimeBeforeTokenExpiresInSeconds: 10,
            useRefreshToken: true,
            logLevel: LogLevel.Debug,*/
        },
      }),
  AppRoutingModule,
    BrowserModule,
    
    BrowserAnimationsModule,
   // AngularFontAwesomeModule,
    ReactiveFormsModule,
    FormsModule,
    EditorModule,
    HttpClientModule,
    MatExpansionModule,
    MatSortModule,
    MatSelectModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatDialogModule,
    MatAutocompleteModule,
    MatInputModule,
    MatRadioModule,
    MatCardModule,
    MatSnackBarModule,
    CalendarModule,
    SelectButtonModule,
    DialogModule,
    SliderModule,
    DropdownModule,
    FieldsetModule,
    InputSwitchModule,
    QuillModule.forRoot(),
    ListboxModule,
    AccordionModule,
    CheckboxModule,
    MenubarModule,
    TableModule,
    ButtonModule,
    DialogModule,
    MatSidenavModule,
    InputTextModule,
    MatBottomSheetModule,
    ToastModule,
    ImageCropperModule,
    ProgressSpinnerModule,
    ToggleButtonModule,
    SplitButtonModule,
    ToastModule,
    PanelMenuModule,
    CheckboxModule,
    AutoCompleteModule,
    SelectModule,
    DatePickerModule,
    ConfirmDialogModule,
    DrawerModule,
    MultiSelectModule,
    PopoverModule,
TreeTableModule
  ],
  exports: [EditorModule],
  providers: [ConfirmationService,
    
     provideAnimationsAsync(),
        providePrimeNG({
            theme: {
                preset: Aura
            },
             translation: {
        accept: 'Ja',
        reject: 'Nej',
        //translations
    }

        }),
    provideNgxMask(),
    AuthGuardService,
    AuthService,
    RoleguardService,
    ErrorService,
    MemberformService,
    MatDatepickerModule,
    MemberService,
NavbarService,
MessageService,
VideoService,

DatePipe,

  //  {provide: MAT_DATE_LOCALE, useValue: 'sv-SE'},
  //  { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
    // UserManager,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpConfigInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderInterceptorService,
      multi: true
    },
    {
      provide: RouteReuseStrategy, useClass: CustomReuseStrategy
    },
    CreateMemberCanDeactivateGuardService
  ],
  //entryComponents: [ConfirmdialogComponent],
  bootstrap: [
    AppComponent
  ],
 
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
